import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Observable} from 'rxjs';
import {TemplateSchema} from "../interfaces/template";
import {TemplateService} from "../services/template.service";

@Injectable({providedIn: 'root'})
export class TemplatePageResolver implements Resolve<TemplateSchema> {
    constructor(private templateService: TemplateService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<TemplateSchema> {
        return this.templateService.getTemplate(route.data['templateId']);
    }
}
